// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".div-options[data-v-7d313c77]{height:inherit;margin-top:1.25rem}", ""]);
// Exports
module.exports = exports;
